import { useRef } from 'react';
import ModalOverlay from './ModalOverlay';
import useModalFocus from '../../hooks/useModalFocus';
import useScrollLock from '../../hooks/useScrollLock';
import styles from './Sheet.module.css';

/**
 * Bottom sheet (mobile counterpart of Popover). Scrim = ModalOverlay; Esc + focus trap + restore = useModalFocus.
 *   <Sheet open onClose label><Sheet.Header/><Sheet.Body/></Sheet>
 *   `full`: full-screen (search palette).
 */
export default function Sheet({ open, onClose, label, full = false, children }) {
  const panelRef = useRef(null);
  useModalFocus(panelRef, onClose, open);
  useScrollLock(open);
  if (!open) return null;
  return (
    <ModalOverlay onClose={onClose} className="modal-overlay--sheet">
      <section ref={panelRef} className={`${styles.sheet}${full ? ` ${styles.full}` : ''}`} role="dialog" aria-modal="true" aria-label={label} tabIndex={-1}>
        <span className={styles.handle} aria-hidden="true" />
        {children}
      </section>
    </ModalOverlay>
  );
}

function Header({ children }) {
  return <div className={styles.header}>{children}</div>;
}

function Body({ children }) {
  return <div className={styles.body}>{children}</div>;
}

Sheet.Header = Header;
Sheet.Body = Body;
